/*
 * File: DeliveryAddressStateSelector.tsx
 * Project: telly-monster
 * -----
 * Last Modified: 18 Jan 2022 12:48:55 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { Form, Select, SelectProps } from 'antd';
import { FormLabel } from 'components/UI/FormItems/FormLabel';
import { State } from 'country-state-city';
import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { Address } from 'redux/services/chuckieSue/models/addresses';

interface Props extends SelectProps {
  fieldName: string;
}

export const StateSelectInput = ({ ...rest }: Props): JSX.Element => {
  const { getFieldMeta, setValues, getFieldHelpers, values } = useFormikContext<Address>();
  const { value, touched, error } = getFieldMeta<string>('localCode');
  const { setTouched } = getFieldHelpers('localCode');
  const selectedCountry = values.country?.alpha2Code;

  const states = selectedCountry ? State.getStatesOfCountry(selectedCountry) : [];

  const stateOptions = states.map((subdivision) => ({ label: subdivision.name, value: subdivision.isoCode }));

  const onChange = (value: string) => {
    setValues((prev) => ({
      ...prev,
      subdivision: {
        ...prev.subdivision,
        categoryName: 'State',
        localCode: value,
        name: states.find((state) => state.isoCode === value)?.name ?? ''
      }
    }));
  };

  useEffect(() => {
    return () => {
      setTouched(true);
    };
  }, []);
  /* ****************** Render ****************** */
  return (
    <Form.Item validateStatus={touched && error ? 'error' : 'success'} style={{ margin: 0 }} label={<FormLabel label="State | Province" />}>
      <Select
        style={{ margin: 0 }}
        value={values.subdivision.localCode || undefined}
        onSelect={onChange}
        placeholder="Select a State"
        showSearch
        options={stateOptions}
        filterOption={(input, option): boolean => {
          if (option?.label) {
            return (option?.label as unknown as string).toLowerCase().includes(input.toLowerCase());
          } else {
            return false;
          }
        }}
        {...rest}
      />
    </Form.Item>
  );
};
